
const UpdateWarning = () => (
  <svg width="24" height="18" viewBox="0 0 24 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M19.479 7.092C19.267 3.141 16.006 0 12 0C7.994 0 4.733 3.141 4.521 7.092C1.951 7.555 0 9.798 0 12.5C0 15.537 2.463 18 5.5 18H18.5C21.537 18 24 15.537 24 12.5C24 9.798 22.049 7.555 19.479 7.092ZM12.002 11C11.588 11 11.252 10.664 11.252 10.25V5.77921C11.252 5.36521 11.586 5 12 5C12.414 5 12.752 5.36521 12.752 5.77921V10.25C12.752 10.664 12.416 11 12.002 11ZM13 13C13 13.552 12.552 14 12 14C11.448 14 11 13.552 11 13C11 12.448 11.448 12 12 12C12.552 12 13 12.448 13 13Z" />
  </svg>
);

export default UpdateWarning;
